
export const checkTransactionData = (transactionData) => {
    if (transactionData.file) {
        return true
    } else {
        return false
    }
}


export const getTransactionDataRequest = (transactionData) => {
    return {        
        corporateId: transactionData.id
    }
}

export const dataStatusCheck = (transactionData) => {
    let flag = true;
    for (let i = 0; i < transactionData.length; i++) {
        if (transactionData[i].status === 'PENDING' || transactionData[i].status === 'PROCESSING') {
            flag = false;
            break;
        }
    }
    return flag;
}
